export default "__VITE_ASSET__b54170cb__"